<div
  class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
>
  <h1 class="h2 text-info">{{ 'performances.global.title' | translate }}</h1>
  <div class="btn-toolbar mb-2 mb-md-0">
    <div class="row">
      <div class="col">
        <div class="row form-group mx-3">
          <label for="inputEmail3" class="col-form-label fw-bold text-info"
            >{{ 'performances.global.filters.sectorsLabel' | translate }}</label
          >
          <div class="col">
            <ng-select
              [(ngModel)]="selectedSectors"
              [multiple]="true"
              [maxSelectedItems]="2"
              (change)="onSelectedSector()"
            >
              <ng-option *ngFor="let sector of sectors" [value]="sector.id">{{
                sector.label
              }}</ng-option>
            </ng-select>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="row form-group mx-3">
          <label for="inputEmail3" class="col-form-label fw-bold text-info"
            >{{ 'performances.global.filters.monthLabel' | translate }}
          </label>
          <div class="col">
            <select
              [(ngModel)]="month"
              (ngModelChange)="onMonthChange($event)"
              class="form-control form-control-sm form-select"
              [attr.aria-label]="'performances.global.filters.monthPlaceholder' | translate"
            >
              <option [ngValue]="undefined" selected>{{ 'performances.global.filters.monthPlaceholder' | translate }}</option>
              <option *ngFor="let m of months" [ngValue]="m.id">
                {{ m.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="row form-group mx-4">
          <label for="inputEmail3" class="col-form-label fw-bold text-info"
            >{{ 'performances.global.filters.yearLabel' | translate }}
          </label>
          <div class="col">
            <select
              [(ngModel)]="year"
              (ngModelChange)="onYearChange($event)"
              class="form-control form-control-sm form-select"
              [attr.aria-label]="'performances.global.filters.yearPlaceholder' | translate"
            >
              <option [ngValue]="undefined" selected>{{ 'performances.global.filters.yearPlaceholder' | translate }}</option>
              <option *ngFor="let y of years" [ngValue]="y.id">
                {{ y.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row" *ngIf="performances.length > 0">
  <div class="col-xl-3 col-sm-6 col-12 mb-4">
    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-between px-md-1">
          <div>
            <h3 class="text-info">
              {{
                getCATotal() | currency : "XOF" : "symbol-narrow" : "1.0-2"
              }}
            </h3>
            <p class="mb-0 fw-bold">{{ 'performances.global.stats.totalSales' | translate }}</p>
          </div>
          <div class="align-self-center">
            <i class="fas fa-rocket text-info fa-3x"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-xl-3 col-sm-6 col-12 mb-4">
    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-between px-md-1">
          <div>
            <h3 class="text-info">
              {{
                getTotalReturns()
                  | currency : "XOF" : "symbol-narrow" : "1.0-2"
              }}
            </h3>
            <p class="mb-0 fw-bold">{{ 'performances.global.stats.totalReturnsAmount' | translate }}</p>
          </div>
          <div class="align-self-center">
            <i class="fas fa-rocket text-info fa-3x"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-xl-3 col-sm-6 col-12 mb-4">
    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-between px-md-1">
          <div>
            <h3 class="text-info">{{ getReturnPercentageTotal() }} %</h3>
            <p class="mb-0 fw-bold">{{ 'performances.global.stats.returnRate' | translate }}</p>
          </div>
          <div class="align-self-center">
            <i class="fas fa-rocket text-info fa-3x"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-xl-3 col-sm-6 col-12 mb-4">
    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-between px-md-1">
          <div>
            <h3 class="text-info">
              {{
                getProjectionTotal()
                  | currency : "XOF" : "symbol-narrow" : "1.0-2"
              }}
            </h3>
            <p class="mb-0 fw-bold">{{ 'performances.global.stats.totalProjection' | translate }}</p>
          </div>
          <div class="align-self-center">
            <i class="fas fa-rocket text-info fa-3x"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="table-responsive">
  <table
    *ngIf="selectedSectors!.length == 0"
    class="table align-middle table-hover"
  >
    <thead class="table-light">
      <tr class="rounded">
        <th scope="col">{{ 'performances.global.table.columns.id' | translate }}</th>
        <th scope="col">{{ 'performances.global.table.columns.sectors' | translate }}</th>
        <th scope="col" class="text-center">{{ 'performances.global.table.columns.goals' | translate }}</th>
        <th scope="col" class="text-center">{{ 'performances.global.table.columns.sales' | translate }}</th>
        <th scope="col" class="text-center">{{ 'performances.global.table.columns.returnsAmount' | translate }}</th>
        <th scope="col" class="text-center">{{ 'performances.global.table.columns.returnRate' | translate }}</th>
        <th scope="col" class="text-center">{{ 'performances.global.table.columns.projection' | translate }}</th>
        <th scope="col" class="text-center">{{ 'performances.global.table.columns.salesDetails' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let sector of this.sectors">
        <th scope="row" class="fw-normal">{{ sector.id }}</th>
        <td class="fw-bold text-info">
          {{ sector.label }}
        </td>
        <td
          class="text-center text-primary fw-bold {{
            getGoalCAClass(sector.id!, getCA(sector.id!))
          }}"
        >
          <span >
            {{
              getGoalCA(sector.id!)
                | currency : "XOF" : "symbol-narrow" : "1.0-2"
            }}
          </span>
        </td>
        <td
          class="text-center text-primary fw-bold {{
            getGoalCAClass(sector.id!, getCA(sector.id!))
          }}"
        >
          <span >
            {{
              getCA(sector.id!)
                | currency : "XOF" : "symbol-narrow" : "1.0-2"
            }}
          </span>
          <i-bs
            *ngIf="isGoalCAReached(sector.id!, getCA(sector.id!))"
            name="caret-up-fill"
            class="text-success"
          ></i-bs>
          <i-bs
            *ngIf="!isGoalCAReached(sector.id!, getCA(sector.id!))"
            name="caret-down-fill"
            class="text-danger"
          ></i-bs>
        </td>
        <td
          class="text-center text-primary fw-bold {{
            getGoalReturnRateClass(sector.id!, getReturns(sector.id!))
          }}"
        >
          <span>
            {{
              getReturns(sector.id!)
                | currency : "XOF" : "symbol-narrow" : "1.0-2"
            }}
          </span>
        </td>
        <td class="text-center text-primary fw-bold">
          <span>
            {{ getReturnPercentage(sector.id!) }} %
          </span>
        </td>
        <td class="text-center text-primary fw-bold">
          <span>
            {{
              getProjection(sector.id!)
                | currency : "XOF" : "symbol-narrow" : "1.0-2"
            }}
          </span>
        </td>
        <td class="text-center text-info fw-bold">
          <span class="text-center btn btn-info">
            <a
              class="text-info text-white"
              routerLink="/performances/point-of-sales"
              [queryParams]="{
                sector_id: sector.id,
                start_date: startDate,
                end_date: endDate
              }"
            >
              <i-bs name="eye"></i-bs>
            </a>
          </span>
        </td>
      </tr>
    </tbody>
  </table>

  <table
    *ngIf="selectedSectors!.length > 0"
    class="table align-middle table-hover"
  >
    <thead class="table-light">
      <tr class="rounded">
        <th scope="col">{{ 'performances.global.table.columns.id' | translate }}</th>
        <th scope="col">{{ 'performances.global.table.columns.sectors' | translate }}</th>
        <th scope="col" class="text-center">{{ 'performances.global.table.columns.sales' | translate }}</th>
        <th scope="col" class="text-center">{{ 'performances.global.table.columns.returnsAmount' | translate }}</th>
        <th scope="col" class="text-center">{{ 'performances.global.table.columns.returnRate' | translate }}</th>
        <th scope="col" class="text-center">{{ 'performances.global.table.columns.projection' | translate }}</th>
        <th scope="col" class="text-center">{{ 'performances.global.table.columns.salesDetails' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let performance of this.performances">
        <th scope="row" class="fw-normal">{{ performance.sector_id! }}</th>
        <td class="fw-bold text-info">
          {{ getSectorLabel(performance.sector_id!) }}
        </td>
        <td class="text-center text-primary fw-bold">
          <span>
            {{
              getCA(performance.sector_id!)
                | currency : "XOF" : "symbol-narrow" : "1.0-2"
            }}
          </span>
        </td>
        <td class="text-center text-primary fw-bold">
          <span >
            {{
              getReturns(performance.sector_id!)
                | currency : "XOF" : "symbol-narrow" : "1.0-2"
            }}
          </span>
        </td>
        <td class="text-center text-primary fw-bold">
          <span>
            {{ getReturnPercentage(performance.sector_id!) }} %
          </span>
        </td>
        <td class="text-center text-primary fw-bold">
          <span>
            {{
              getProjection(performance.sector_id!)
                | currency : "XOF" : "symbol-narrow" : "1.0-2"
            }}
          </span>
        </td>
        <td class="text-center text-info fw-bold">
          <span class="text-center btn btn-sm btn-info">
            <a
              class="text-info text-white"
              routerLink="/performances/point-of-sales"
              [queryParams]="{
                sector_id: performance.sector_id!,
                start_date: startDate,
                end_date: endDate
              }"
            >
              <i-bs name="eye"></i-bs>
            </a>
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
